






import { Component, Prop, Vue } from 'vue-property-decorator';
import { ExprConst } from '../../cablin/exprs';
import ValueComp from '../value/Value.vue'

@Component({
  components: {
    ValueComp,
  },
})
export default class ExprConstComp extends Vue {
  @Prop() private expr!: ExprConst
}
